// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2Ufuf","log":"ModalInventoryLogs_log__YB7Lq","date":"ModalInventoryLogs_date__34AmV","userName":"ModalInventoryLogs_userName__2njfh"};